export default __webpack_public_path__ + "static/media/No.f86c5b5b.mp3";